import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import "./permission";
const app = createApp(App);

app.config.globalProperties.$globalconstant = 'https://online.lxbx.net/'
app
    .use(Vant)
    .use(store)
    .use(router)
    .mount('#app')